import { render } from "./index.vue?vue&type=template&id=44da89bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=44da89bc&scoped=true&lang=css"

import exportComponent from "/Users/wangkunyu/Documents/code/ip-js/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44da89bc"]])

export default __exports__